import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';

import { governanceFormSchema } from '../schemas';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(governanceFormSchema),
    defaultValues,
    shouldFocusError: true,
  });
}
